<app-hero [title]="'Kurse'"></app-hero>

<section id="alt-services" class="alt-services section">
  <div class="container">
    <div class="row justify-content-around gy-4">
      <div class="col-lg-5 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
        <h3>Mit Selbstvertrauen Deutsch lernen</h3>

        <p data-aos="fade-up" data-aos-delay="300">
          Unsere Deutschkurse sind für Lernende aller Niveaus konzipiert, von Anfängern bis Fortgeschrittenen, um starke Kommunikationsfähigkeiten aufzubauen. Durch interaktive Lektionen erwerben Sie praktischen Wortschatz, Grammatikkenntnisse und Gesprächssicherheit.
        </p>
        <br>

        <p data-aos="fade-up" data-aos-delay="400">
          Wir konzentrieren uns auf reale Situationen, kulturelles Verständnis und effektive Lernstrategien. Egal, ob Ihr Ziel Reisen, Arbeit oder akademische Zwecke sind, unsere strukturierten Kurse bieten die Werkzeuge, um die deutsche Sprache erfolgreich zu meistern.
        </p>
      </div>
      <div class="features-image col-lg-6" data-aos="fade-up" data-aos-delay="100">
        <img src="assets/img/learn-german.jpg" alt="Deutsch lernen">
      </div>
    </div>
  </div>
</section>

<!-- Constructions Section -->
<section id="constructions" class="constructions section">

  <!-- Section Title -->
  <div class="container section-title" data-aos="fade-up">
    <h2>Kurse</h2>
    <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
  </div><!-- End Section Title -->

  <div class="container">
    <div class="row gy-4">

      <!-- Beginner A1-A2 -->
      <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
        <div class="card-item" (click)="navigateToCourseApplyComponent('A1-A2')">
          <div class="row">
            <div class="col-xl-5">
              <div class="card-bg">
                <img src="assets/img/A1_A2.jpg" alt="Deutsch Anfänger A1-A2">
              </div>
            </div>
            <div class="col-xl-7 d-flex align-items-center">
              <div class="card-body">
                <h4 class="card-title">Anfänger-Deutsch (A1–A2)</h4>
                <p>
                  Beginnen Sie Ihre Reise in Deutsch! Dieser Kurs führt Sie in den Alltagsvokabular, einfache Grammatik und korrekte Aussprache ein. Am Ende werden Sie in der Lage sein, sich vorzustellen, grundlegende Fragen zu stellen und zu beantworten und einfache Gespräche im täglichen Leben wie Einkaufen, Reisen und Begrüßungen zu führen.
                </p>
                <a class="mt-2" (click)="navigateToCourseApplyComponent('A1-A2')">
                  Jetzt bewerben <i class="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div><!-- End Card Item -->

      <!-- Intermediate B1-B2 -->
      <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
        <div class="card-item" (click)="navigateToCourseApplyComponent('B1-B2')">
          <div class="row">
            <div class="col-xl-5">
              <div class="card-bg">
                <img src="assets/img/B1_B2.jpg" alt="Deutsch Fortgeschrittene B1-B2">
              </div>
            </div>
            <div class="col-xl-7 d-flex align-items-center">
              <div class="card-body">
                <h4 class="card-title">Fortgeschrittene Deutsch (B1–B2)</h4>
                <p>
                  Bauen Sie Selbstvertrauen und Flüssigkeit in Deutsch auf. Dieser Kurs konzentriert sich darauf, Ihren Wortschatz zu erweitern, die Satzstruktur zu verbessern und Meinungen zu alltäglichen Themen auszudrücken. Nach Abschluss werden Sie in der Lage sein, längere Texte zu schreiben und zu lesen, Gespräche und Medien zu verstehen und klar in sozialen und beruflichen Kontexten zu kommunizieren.
                </p>
                <a class="mt-2" (click)="navigateToCourseApplyComponent('B1-B2')">
                  Jetzt bewerben <i class="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div><!-- End Card Item -->

    </div>
  </div>

</section><!-- /Constructions Section -->